import { useId } from "react";
import { THEMES } from "../../theme";

export default function ThemePicker({ theme, onChange }) {
  const radioName = useId();
  return (
    <fieldset className="pc-theme-picker">
      <legend>Theme</legend>
      <div className="pc-theme-picker__options">
        {THEMES.map(({ id, name, mode, colors }) => (
          <label key={id} className="pc-theme-picker__option" data-selected={theme === id}>
            <input type="radio" name={radioName} value={id} aria-label={name}
              checked={theme === id} onChange={() => onChange(id)} />
            <span className="pc-theme-picker__preview" aria-hidden="true"
              style={{ background: colors.page, borderColor: colors.border }}>
              {[colors.header, colors.primary, colors.raised].map((color, index) => (
                <i key={index} style={{ background: color }} />
              ))}
            </span>
            <span className="pc-theme-picker__name">{id === "light" ? "Classic" : name}<small>{mode === "dark" ? "Dark" : "Light"}</small></span>
          </label>
        ))}
      </div>
    </fieldset>
  );
}
